module.exports = __webpack_public_path__ + "img/04-3-5统一业务.98ae9370.svg";